import { Modal } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import Caution from "../../../../assets/cautionsuccessicons.svg";
const MerchantVehicleSuccess = (props: any) => {
  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={400}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div
          className={Styles.modalContentVerification}
          style={{ paddingTop: "2em" }}
        >
          <div className={Styles.cautionDiv} style={{ marginTop: "0em" }}>
            <img
              onClick={props.handleCancel}
              src={Caution}
              className={Styles.cautionIcon}
              alt="horse"
            />
          </div>
          <div style={{ textAlign: "center" }} className={Styles.title}>
            Request made successfully
          </div>
          <div style={{ textAlign: "center" }} className={Styles.descThree}>
          <div style={{textAlign:'center'}} className={Styles.desc}>Your loan request has been made successfully and is currently being processed. You will be notified when processing is complete.</div>
          </div>
          <button onClick={props.goToHistory} className={Styles.btn}>
            RETURN TO VEHICLE HISTORY
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantVehicleSuccess;
